export namespace BootstrapApiUri {
  const BASE_URL = '/lcm/bootstrap';

  export const BOOT_STATUS_URL = `${BASE_URL}/api/status`;

  export const DOWNLOAD_BOOTSTRAP_LOGS_URL = `${BASE_URL}/api/log/download`;
}
